module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "advert-data"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('span', [_vm._v("信息流广告 >")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.advertTitle) + "的信息流广告 >")]), _vm._v(" "), _c('span', [_vm._v("广告详情")]), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "advert-detail"
  }, [_c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("广告标题：" + _vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("广告说明：" + _vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("图 片：")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("曝光数：" + _vm._s(_vm.exposure))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("点击人数：" + _vm._s(_vm.clickUserCount))])]), _vm._v(" "), _c('div', {
    staticClass: "detail-item"
  }, [_c('span', [_vm._v("点击数：" + _vm._s(_vm.clickCount))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cc0b4de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/advert/advertData.vue
// module id = 938
// module chunks = 0